package com.partejar.app.feature.relacionamentos.presentation

import kotlinx.datetime.LocalDate

/** Early app validation only; signature and activation rules remain on the API. */
internal data class RelationshipContractErrors(val babyName: String?, val dueDate: String?) {
    val hasErrors: Boolean get() = babyName != null || dueDate != null

    val summary: String? get() = when {
        babyName != null && dueDate != null -> "Informe o nome do bebê e a DPP antes de avançar para o contrato."
        babyName != null -> "Informe o nome do bebê antes de avançar para o contrato."
        dueDate != null -> "Informe a DPP antes de avançar para o contrato."
        else -> null
    }
}

internal fun relationshipContractErrors(babyName: String?, dueDateIso: String?): RelationshipContractErrors =
    RelationshipContractErrors(
        babyName = if (babyName.isNullOrBlank()) "Informe o nome do bebê para continuar." else null,
        dueDate = when {
            dueDateIso.isNullOrBlank() -> "Informe a DPP para continuar."
            runCatching { LocalDate.parse(dueDateIso) }.isFailure -> "Informe uma DPP válida para continuar."
            else -> null
        }
    )
